module.exports = __webpack_public_path__ + "static/media/retry.8fa7789f.svg";